import './RelatedEvents.scss'

import {Carousel, useCarousel} from '@codeurs/carousel'
import React from 'react'
import {useLocation} from 'react-router'
import {style} from 'util/style'
import {useTranslation} from '../../util/i18n'
import {Theme} from '../Theme'
import {MarkedTitle} from '../ui/MarkedTitle'
import {CardSwitchType} from './cards/CardSwitch'
import {EventCard} from './cards/EventCard'
import {ProjectCard, ProjectCardType} from './cards/ProjectCard'

const styles = style('relatedevents')

type RelatedEventsType = {
	project: ProjectCardType
	events: Array<CardSwitchType>
	linkToEventspage: string
}

export const RelatedEvents: React.FC<RelatedEventsType> = ({
	linkToEventspage,
	project,
	events = []
}) => {
	const t = useTranslation('events').related
	const carousel = useCarousel()
	const location = useLocation()
	const hasProject = !!project

	const filteredEvents = events
		.filter(
			(event) =>
				event.url !== `//${window.location.hostname}${location.pathname}` &&
				event.url !== location.pathname
		)
		.map((event) => event)
	const hasFilteredEvents = filteredEvents?.length > 0

	if (!hasProject && !hasFilteredEvents) return null

	return (
		<div className={styles}>
			<Theme.Container>
				<div className={styles('row')}>
					{hasProject && (
						<div className={styles('row-project')}>
							<div className={styles('row-project-card')}>
								<MarkedTitle direction="left" title={t.benefit} />
								<ProjectCard {...project} />
							</div>
						</div>
					)}
					{hasFilteredEvents && (
						<div className={styles('row-events')}>
							<div className={styles('row-events-top')}>
								<Theme.H3
									className={styles('row-events-top-title')}
									mod={['marked', 'slantleft', 'white']}
								>
									{t.title}
								</Theme.H3>
								{linkToEventspage && (
									<Theme.Link
										iconafter="chevronRight"
										className={styles('row-events-top-link')}
										to={linkToEventspage}
									>
										{t.all_events}
									</Theme.Link>
								)}
							</div>
							<div className={styles('row-events-carousel')}>
								<Carousel {...carousel} full>
									{filteredEvents.map((event, i) => (
										<div
											key={i}
											className={styles('row-events-carousel-slide')}
										>
											<EventCard {...event} />
										</div>
									))}
								</Carousel>
							</div>
						</div>
					)}
				</div>
			</Theme.Container>
		</div>
	)
}
